import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=97fd1ede"
import script from "./EditCoupon.vue?vue&type=script&lang=js"
export * from "./EditCoupon.vue?vue&type=script&lang=js"
import style0 from "./EditCoupon.vue?vue&type=style&index=0&id=97fd1ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports